import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Shop } from 'src/app/shared/fcmodel/shop';
import { map } from 'rxjs/operators';

@Injectable()
export class ShopService  {
//  isEskyAdmin:boolean;
private headerOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

   constructor(private http: HttpClient ) { }
   all(){

    return this.http.get('api/shop/all').pipe(map((res: Response) => res));
   }
   getALLOrderStatus(token,domain){
    return this.http.get('api/prestashop/testConnection?token='+token+"&&domain="+domain).pipe(map((res: Response) => res));

  }
  deleteOrderStatus(selectedorderStatus){
    return this.http.post(
   'api/prestashop/deleteOrderStatus?idOrderStatus='+selectedorderStatus.id,this.headerOptions)
}
createPrestaShop(shop:Shop){
  let params: HttpParams = new HttpParams()
  .set('alias',  JSON.stringify(shop));
/*  params.set('alias', shop.alias);
  //params.set('domain', shop.domain);
  //params.set('token', shop.password);*/
   //params.set('checkedstatus', JSON.stringify(statusChecked));
   this.headerOptions["search"] = params;
  return this.http.post(
    //?alias='+shop.alias+'&&domain='+ shop.domain+'&&token='+shop.password+'&&c
    'api/prestashop/addShop',JSON.stringify(shop),
{params}
    //this.headerOptions
  )
}
   getprestashoplistOrderStatus(shopId){
  	return this.http.get('api/prestashop/listStatus?shopId='+shopId).pipe(map((res: Response) => res));
  	}
    //add new prestashop order status
    addOrderStatus(listorderStatus){
      return this.http.post(
        'api/prestashop/addOrderStatus',
        JSON.stringify(listorderStatus),
        this.headerOptions
      )
    }
   addnewshopfiy(data)
   {
     return this.http.post(
        'api/shop/addshopify',
        JSON.stringify(data),
        this.headerOptions
      )
   }
      // get fb status from config file
  getFBOrderStatus(){
    return this.http.get('api/prestashop/getallFBorderstatus').pipe(map((res: Response) => res));

  }
   addneworders(id){
     return this.http.post(
        'api/orders/addorders?shopid='+id,
        this.headerOptions
      )
   }
   checkdomain(domain:string){

     let params: HttpParams = new HttpParams()
      .set('domain', domain);
  return this.http.get('api/shop/checkdomain', {params}).pipe(map((res: Response) => res));
 }
 checkalias(alias:string){

   let params: HttpParams = new HttpParams()
    .set('alias', alias);

 return this.http.get('api/shop/checkalias', {params}).pipe(map((res: Response) => res));
 }
 shopifytestconnection(domain:string,apikey:string,password:string){

   let params: HttpParams = new HttpParams()
    .set('domain', domain)
    .set('apikey', apikey)
    .set('password', password);
 return this.http.get('api/shop/shopifytestconnection', {params}).pipe(map((res: Response) => res));
 }

  getScope(){
    return this.http.get('api/shopify/getscope',  {responseType: 'text'})
  }
  amazontestconnection(sellerId:string,amwsToken:string){
   let params: HttpParams = new HttpParams()
    .set('sellerId', sellerId)
    .set('amwsToken', amwsToken);
 return this.http.get('api/shop/amazontestconnection', {params}).pipe(map((res: Response) => res));
 }

 addnewamazon(data)
   {
     return this.http.post(
        'api/shop/addamazon',
        JSON.stringify(data),
        this.headerOptions
      )
   }
  checkShopifyUrl(domain:string){

     let params: HttpParams = new HttpParams()
      .set('domain', domain);

  return this.http.get('api/shopify/checkurl', {params}).pipe(map((res: Response) => res));
 }
  //get shopify store location
     getShopLocations(shopId){

    return this.http.get('api/shopify/getShopifyLocations?shopId='+shopId).pipe(map((res: Response) => res));
   }

    addShopifyShopLocations(data)
  {
    return this.http.post(
       'api/shop/addShopifyLocations',
       JSON.stringify(data),
       this.headerOptions
     ).pipe(map((res: Response) => res));
  }
//get created locatins by shop
   getCreatedLocations(shopId){

    return this.http.get('api/shop/getShopLocations?shopId='+shopId).pipe(map((res: Response) => res));
   }
 testWooCommerceConnection(domain:string,apiKey:string,apiSecret:string){
   let params: HttpParams = new HttpParams()
   .set('domain', domain)
    .set('apiKey', apiKey)
    .set('apiSecret', apiSecret);
 return this.http.get('api/shop/testWordpressConnection', {params}).pipe(map((res: Response) => res));
 }
 CreateWoocommerceShop(shop){
   return this.http.post(
        'api/shop/createWoocommerceShop',
        JSON.stringify(shop),
        this.headerOptions
      )
 }
 createNewTradegecko(data)
   {
     return this.http.post(
        'api/tradegecko/createNewAccount',
        JSON.stringify(data),
        this.headerOptions
      )
   }
    getShopTradeLocations(shopId:any){

    return this.http.get('api/tradegecko/getTradeGeckoLocations?shopId='+shopId).pipe(map((res: Response) => res));
   }
     addTradeLocations(data)
  {
    return this.http.post(
       'api/shop/addTradeLocations',
       JSON.stringify(data),
       this.headerOptions
     )
  }
   getShop(shopId){
   return this.http.get('api/shop/getShop?shopId='+shopId).pipe(map((res: Response) => res));
 }
 testShipStationConnection(apikey:string,password:string){
   let params: HttpParams = new HttpParams()
  .set('apiKey', apikey)
    .set('apiSecret', password);
 return this.http.get('api/shop/testShipstationConnection',  {params}).pipe(map((res: Response) => res));
 }
 createNewShipstationCnx(data)
   {
     return this.http.post(
        'api/shipstation/createShipstationSource',
        JSON.stringify(data),
        this.headerOptions
      )
   }
  createShopShopifyNonConnected(shop,username,token){
    console.log("executing the creation fo the shop");
    return this.http.post('api/shopify/createShopifyShop/'+shop+'/'+username+'/'+token,this.headerOptions)
   }

   testMagentoConnection(domain:string,token:string){
  return this.http.get('api/shop/magento/testConnection?domain='+domain+'&token='+token);
  }

  saveDelayRefresh(delay){
    return this.http.post(
      'api/company/saveDelayRefreshOrder?fixedDelay='+delay,this.headerOptions)

   }
   getDelayRefresh(){
    return this.http.get('api/company/getDelayRefreshOrder');
  }
  allEnabledAutoRefresh(){
    return this.http.get('api/shop/allActivateAutoImport');
   }

   activateAutoRefreshOrders(shop){
    return this.http.post(
      'api/shop/activateRefreshOrders', JSON.stringify(shop),this.headerOptions
    )
  }
  activateAutoFulfillOrders(shop){
    return this.http.post(
      'api/shop/activateAutoFulfillOrders', JSON.stringify(shop),this.headerOptions
    )
  }
  addnewMagento(data)
  {
    return this.http.post(
       'api/shop/magento/add',
       JSON.stringify(data),
       this.headerOptions
     )
  }
  createMagentoOrderStatus(shopId,magentoStatus,fbStatus){

    return this.http.post(
      'api/shop/magento/addOrderStatus?shopId='+shopId+'&magentoStatus='+magentoStatus+'&fbStatus='+fbStatus,this.headerOptions);
    }

    getmagentolistOrderStatus(shopId){
      return this.http.get('api/shop/magento/listStatus?shopId='+shopId);
      }
}
